// @flow

import React, { Component } from 'react';

import './Popup.css';

class Popup extends Component {
  render() {
    return (
      <div className="Popup">
        <div className="close" onClick={this.props.onClose}>
          <i className="material-icons md-18">close</i>
        </div>
        <div>{this.props.children}</div>
      </div>
    );
  }
}

export default Popup;



// WEBPACK FOOTER //
// ./src/components/Popup/Popup.js